import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { useServices } from "@website/widget/header";
import { useState } from "react";
export function TravelServicesDesktop() {
  const $ = _c(17);
  const {
    services
  } = useServices();
  const [activeService, setActiveService] = useState(services[0]);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button className="!mx-0" EndIcon={<MaterialIcon name="keyboard_arrow_down" />} aria-label={"\u062E\u062F\u0645\u0627\u062A \u0645\u0633\u0627\u0641\u0631\u062A\u06CC"} color="neutral" size="medium" variant="text">خدمات مسافرتی</Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-headline-6 text-on-surface-high-emphasis m-0 flex h-12 items-center">خدمات سفر</span>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== services) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = item => <a className="hover:bg-states-secondary-dragged group/link group-hover/link:text-secondary flex h-12 w-48 items-center justify-start gap-2 rounded-lg px-2 py-3 transition-all" href={item.url} key={item.title} onMouseEnter={() => setActiveService(item)}><span className="text-on-surface-medium-emphasis group-hover/link:fill-on-surface-secondary-high-emphasis fill-on-surface-medium-emphasis group-hover/link:text-secondary text-2xl">{item.icon}</span><div className="text-body-1 text-on-surface-high-emphasis group-hover/link:text-secondary">{item.title}</div></a>;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = services.map(t3);
    $[2] = services;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="bg-dim-background group shrink-0 rounded-lg px-3 py-2">{t1}<div>{t2}</div></div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== activeService || $[8] !== services) {
    let t5;
    if ($[10] !== activeService) {
      t5 = item_0 => {
        const isActive = activeService === item_0;
        return <div aria-hidden={!isActive} className={isActive ? "relative" : "pointer-events-none invisible absolute inset-0 opacity-0"} key={item_0.title}>{item_0.links}</div>;
      };
      $[10] = activeService;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t4 = services.map(t5);
    $[7] = activeService;
    $[8] = services;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <div className="relative hidden shrink-0 group-hover:block">{t4}</div>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t5) {
    t6 = <div className="group relative hidden h-full items-center lg:flex">{t0}<section className="pointer-events-none invisible absolute -right-16 top-0 z-50 w-max translate-y-20 py-1 opacity-0 transition-all group-hover:pointer-events-auto group-hover:visible group-hover:top-[56px] group-hover:translate-y-2 group-hover:opacity-100"><div className="elevation-8 rounded-lg"><div className="rounded-lg p-4"><div className="flex gap-2">{t3}{t5}</div></div></div></section></div>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}